/* ========================== */
/*          VENTAJAS          */
/* ========================== */

ventajas = {
    init: function () {
        if ($(".ventajas-item").length > 0) {
            $(".ventajas-item").each(function (index) {
                var item = $(this);
                var key = $(this).data("key");
                var controller = new ScrollMagic.Controller();

                var scene = new ScrollMagic.Scene({
                    triggerElement: '.ventajas-item.item-' + key,
                    triggerHook: "0.4",
                    duration: item.outerHeight(),
                }).on('enter', function () {
                    $('.item-' + key).addClass("active");
                }).on('leave', function () {
                    $('.item-' + key).removeClass("active");
                }).addTo(controller);
            });
        }
    }
};

$(document).ready(function () {
    ventajas.init();
});


